/// <reference path="../types.d.ts" />
import { createReducer } from '@reduxjs/toolkit';
import InitialState from '../reducers/initial-state';
import { LOAD_STATES } from './common';
import * as assigningAuthorityActions from '../actions/assigning-authorities';
import { jumpContext } from '../actions/contexts.action';
import { logout } from '../actions/ui';
const reducer = createReducer(InitialState.assigningAuthorities, (builder)=>{
    builder.addCase(logout.type, ()=>({
            ...InitialState.assigningAuthorities
        }));
    builder.addCase(jumpContext.pending.type, ()=>({
            ...InitialState.assigningAuthorities
        }));
    builder.addCase(assigningAuthorityActions.getHospitals.pending, (state)=>({
            ...state,
            loadState: LOAD_STATES.started
        }));
    builder.addCase(assigningAuthorityActions.getHospitals.rejected, (state)=>({
            ...state,
            loadState: LOAD_STATES.failed
        }));
    builder.addCase(assigningAuthorityActions.getHospitals.fulfilled, (state, action)=>{
        var list = [];
        action.payload.forEach((element)=>{
            list.push({
                id: element.hospitalId,
                hospitalName: element.hospitalName
            });
        });
        return {
            ...state,
            items: list,
            loadState: LOAD_STATES.done
        };
    });
    builder.addCase(assigningAuthorityActions.loadForm.pending, (state)=>({
            ...state,
            loadState: LOAD_STATES.started
        }));
    builder.addCase(assigningAuthorityActions.loadForm.rejected, (state)=>({
            ...state,
            loadState: LOAD_STATES.failed
        }));
    builder.addCase(assigningAuthorityActions.loadForm.fulfilled, (state, action)=>({
            ...state,
            activeItem: action.payload.group,
            currentHositalId: action.payload.id,
            loadState: LOAD_STATES.done
        }));
});
export default reducer;
